import AddRolesBusinessEntityLeaf from './AddRolesBusinessEntityLeaf'
const AddRolesBusinessEntityLeaves = ({ companies, selectedRoleIdSignal, selectedOrganizationsSignal, depth, enableAddRoleSignal }) => {
	let leaves = []
	for(let i = 0; i < companies.length; i++){
		leaves.push(
			<AddRolesBusinessEntityLeaf
				key={companies[i].id}
				childOrg={companies[i]}
				selectedRoleIdSignal={selectedRoleIdSignal}
				selectedOrganizationsSignal={selectedOrganizationsSignal}
				depth={depth}
				enableAddRoleSignal={enableAddRoleSignal}
			></AddRolesBusinessEntityLeaf>
		)
	}
	return <>{leaves}</>
}
export default AddRolesBusinessEntityLeaves